import {
  DownloadOutlined,
  ImportOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { Alert, Button, Form, message, Modal, Space, Upload } from "antd";
import { useForm } from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import { customerApi } from "api/customer.api";
import { shopApi } from "api/shop.api";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { settings } from "settings";
import { toSlug } from "utils/slug";
// import { formatExcelDate } from "utils/formatExcelDate";
import * as XLSX from "xlsx";
const { Dragger } = Upload;

export interface IShopData {
  name: string;
  phone: string;
  businessArea: string;
  companyName: string;
  userPositionId?: number;
}

export const ImportShopModal = ({
  visible,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [loading, setLoading] = useState(false);
  const [excelData, setExcelData] = useState<any>();
  const [isDisabled, setisDisible] = useState(true);
  const [results, setResults] = useState<
    { status: string; message?: string }[]
  >([]);

  const [form] = useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
      setResults([]);
    }
  }, [visible]);

  const readExcel = (file: any) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();

      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target?.result;

        const wb = XLSX.read(bufferArray, { type: "buffer" });

        const wbname = wb.SheetNames[0];

        const ws = wb.Sheets[wbname];

        const data = XLSX.utils.sheet_to_json(ws);

        resolve(data);
      };
    });

    promise.then((d) => {
      setisDisible(false);
      const data = Array(d);

      setExcelData(data[0]);
    });
  };

  console.log("excelData", excelData);

  const importData = () => {
    const dataPost = excelData.map((record: any) => {
      return {
        name: record["Tên thành viên"],
        phone: record["Điện thoại"],
        businessArea: record["Ngành nghề"],
        companyName: record["Tên công ty"],
      };
    });

    //post data

    // console.log("dataposst", dataPost);

    dataPost.forEach((data: any, index: number) => {
      addCustomer(data, index);
    });

    onSubmitOk();

    console.log("dataPost", dataPost);
  };

  const addCustomer = async (data: IShopData, index: number) => {
    console.log("data", data.companyName);

    setLoading(true);
    let message;
    const resultArr = results;
    const shop = {
      name: data.companyName,
      phone: data.phone,
      businessArea: data.businessArea,
    };

    //Check object not undefined
    if (shop.name && shop.phone && shop.businessArea) {
      try {
        const res = await shopApi.create({
          shop,
        });
        if (res) {
          await shopApi.updateAccount(res.data.id, {
            username: toSlug(data.name),
            password: "123456",
            name: data.name,
            phone: data.phone,
          });
          const status = "success";
          resultArr.push({ status, message });
          setResults([...resultArr]);
          console.log("ressuccess", res);
        }
      } catch (error: any) {
        const status = "error";
        message = `${error.response.data.message} (dòng ${index})`;
        resultArr.push({ status, message });
        setResults([...resultArr]);
      }
    }

    setLoading(false);
  };

  return (
    <Modal
      style={{ top: 50 }}
      onCancel={onClose}
      open={visible}
      title="Import Khách hànga"
      confirmLoading={loading}
      footer={[
        <Button
          type="primary"
          disabled={isDisabled}
          onClick={importData}
          icon={<ImportOutlined />}
          loading={loading}
        >
          Bắt đầu import
        </Button>,
        <Button onClick={onClose}>Đóng</Button>,
        ...(settings.isDev
          ? [<Button onClick={() => {}}>Lấy data</Button>]
          : []),
      ]}
    >
      <Link to="/files/ImportMember.xlsx" target="_blank" download>
        <Space>
          <DownloadOutlined />
          Tải file excel mẫu
        </Space>
      </Link>
      <Form form={form}>
        <FormItem key="uploadField" name="uploadField">
          <Dragger
            style={{ marginTop: "0.5em" }}
            maxCount={1}
            multiple={false}
            beforeUpload={(file) => {
              //Check file type
              const isExcelFile =
                file.name.includes("xls") || file.name.includes("xlsx");
              if (!isExcelFile) {
                console.log(file.type);
                message.error("Chỉ chấp nhận file XLSX/XLS!");
                return Upload.LIST_IGNORE;
              }

              readExcel(file);
              return false;
            }}
            onChange={(info) => {
              //reset data
              setResults([]);
              if (info.fileList.length == 0) {
                setisDisible(true);
              }
            }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Ấn vào đây hoặc kéo thả để tải file lên
            </p>
          </Dragger>
        </FormItem>
      </Form>
      {results.length > 0 && (
        <>
          <Alert
            style={{ marginTop: "1em", marginBottom: "1em" }}
            message={`${results.filter((r) => r.status == "success").length}
            khách hàng được thêm,
            ${results.filter((r) => r.status == "error").length} lỗi`}
            type="info"
            showIcon
          />
        </>
      )}
      {results.filter((r) => r.status == "error").length > 0 && (
        <>
          <b>Chi tiết lỗi:</b>
          <div className="error-container">
            {results
              .filter((r) => r.status == "error")
              .map((r, index) => (
                <>
                  <Alert
                    style={{ marginTop: "1em" }}
                    message={`${r.message}`}
                    type="error"
                    showIcon
                  />
                </>
              ))}
          </div>
        </>
      )}
      <Space
        style={{ width: "100%", justifyContent: "end", marginTop: "1em" }}
      ></Space>
    </Modal>
  );
};
